import { render, staticRenderFns } from "./CalculateUpload.vue?vue&type=template&id=6c1a3300"
import script from "./CalculateUpload.vue?vue&type=script&lang=js"
export * from "./CalculateUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports